import 'zone.js';

(() => {
  try {
    // Buscar el descriptor en window y globalThis (depende del bundler)
    const descriptor = Object.getOwnPropertyDescriptor(window, 'Promise') ||
                       Object.getOwnPropertyDescriptor((window as any), 'Promise') ||
                       Object.getOwnPropertyDescriptor(globalThis, 'Promise');

    if (descriptor) {
      Object.defineProperty(window, 'Promise', {
        value: descriptor.value,
        writable: false,
        configurable: false,
        enumerable: descriptor.enumerable !== undefined ? descriptor.enumerable : true,
      });
      if (globalThis !== window) {
        Object.defineProperty(globalThis, 'Promise', {
          value: descriptor.value,
          writable: false,
          configurable: false,
          enumerable: descriptor.enumerable !== undefined ? descriptor.enumerable : true,
        });
      }
      console.log('[polyfills] window.Promise protegido contra reescrituras.');
    }
  } catch (err) {
    console.warn('[polyfills] No se pudo proteger window.Promise:', err);
  }
})();
